module.exports = __webpack_public_path__ + "img/20190529105008微信截图_20190529105347.ffc6b842.png";